<template>
  <div>
    <router-link
      :to="{ name: class_router_names.detailPage, params: { id: item.id } }"
    >
      <md-button class="md-just-icon md-success md-simple table-action ">
        <md-tooltip md-direction="top">{{ $t("common.view") }} </md-tooltip>
        <md-icon>visibility</md-icon>
      </md-button>
    </router-link>
  </div>
</template>

<script>
import { class_router_names } from "@/routes/routes";
export default {
  props: ["item"],
  data() {
    return {
      class_router_names
    };
  }
};
</script>

<style lang="scss" scoped>
.table-action {
  padding: 0 5px;
  margin: 0 2px;
}
</style>
